<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-if="copyImportValue"
                v-bind="attrs"
                v-on="on"
                icon
                :color="check ? 'teal': 'red'"
                @click="copyToClipboard(newValue)"
            >
                <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-icon
                v-else
                v-bind="attrs"
                v-on="on"
                :color="check ? 'teal': 'red'"
            >
                mdi-check-circle
            </v-icon>

        </template>
        <ul>
            <li>WIMS: {{ originalValue }}</li>
            <li>IMPORTER: {{ newValue }}</li>
        </ul>
    </v-tooltip>
</template>

<script>
import useSharedMethod from "@/use/SharedMethod";

export default {
    name: "CompareStateTd",
    props: {
        check: Boolean,
        originalValue: String,
        newValue: String,
        copyImportValue: Boolean
    },
    setup() {
        const {copyToClipboard} = useSharedMethod();

        return {
            copyToClipboard,
        }
    }
}
</script>

<style scoped>

</style>